import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { UsersDataSource } from "../datasources/users.datasource";

export type AccountType = 'edu' | 'one' | 'ind';

@Injectable({ providedIn: 'root' })
export class UsersRepository {
    disable2fa(data: { discode: any; }) {
        return this.datasource.disable2fa(data);
    }
    setup2fa() {
        return this.datasource.setup2fa();
    }
    verify2fa(data: any) {
        return this.datasource.verify2fa(data);
    }
	checkCoupon(value: string) {
		 return this.datasource.checkCoupon(value);
	}
  getNotifications(filters?: { unread?: boolean; date_from?: string; date_to?: string }) {
    return this.datasource.getNotifications(filters);
  }
  postReadNotifications(notifications_id: any) {
    return this.datasource.postReadNotifications(notifications_id);
  }
  deleteUserPhoto(id: any) {
    return this.datasource.deleteUserPhoto(id);
  }
  getUserPhotos() {
    return this.datasource.getUserPhotos();
  }
  postUserConfiguration(data: any){
    return this.datasource.postUserConfiguration(data);
  }
  getUserConfiguration(){
    return this.datasource.getUserConfiguration();
  }
  postUserSkills(data: any){
    return this.datasource.postUserSkills(data);
  }
  getUserSkills(){
    return this.datasource.getUserSkills();
  }
  getUserTemplates(){
    return this.datasource.getUserTemplates();
  }
  postUserTemplate(data: { name: string; text: string }){
    return this.datasource.postUserTemplate(data);
  }
  putUserTemplate(id: number, data: { name: string; text: string }){
    return this.datasource.putUserTemplate(id, data);
  }
  deleteUserTemplate(id: number){
    return this.datasource.deleteUserTemplate(id);
  }
  getUserCustomer(){
    return this.datasource.getUserCustomer();
  }
  deleteUserMeta(id: number) {
    return this.datasource.deleteUserMeta(id);
  }
  getUserTeam() {
    return this.datasource.getUserTeam();
  }
  postUserMeta(phones: any) {
      return this.datasource.postUserMeta(phones);
  }
  postUserEvent(data: { event: string; type?: string; name?: string; id?: string }) {
      return this.datasource.postUserEvent(data);
  }
  getUserOrganization() {
      return this.datasource.getUserOrganization()
  }
  putUserOrganization(data: any) {
      return this.datasource.putUserOrganization(data)
  }
  getUserGroups(){
    return this.datasource.getUserGroups()
  }
  getLocations() {
    return this.datasource.getLocations();
  }
  getUserId(){
    return this.datasource.getUserId()
  }
  getMagicUser(magic:string){
    return this.datasource.getMagicUser(magic)
  }
  postMagicUser(magic:string, data:any){
    return this.datasource.postMagicUser(magic, data)
  }
    getUserPlan() {
      return this.datasource.getUserPlan();
    }

    constructor( private datasource: UsersDataSource) {}
    updatePassword(old_password: string, new_password: string){
      return this.datasource.updatePassword(old_password, new_password);
    }
    postPurchasePlan(value: any) {
      return this.datasource.postPurchasePlan(value);
    }
    putUserPlan(data: { plan_id: any; user_licenses: number }) {
      return this.datasource.putUserPlan(data);
    }
    putProfile(data:any){
      return this.datasource.putProfile(data)
    }
    postVerifyWhatsapp(telephone?: string){
      return this.datasource.postVerifyWhatsapp(telephone)
    }
    putVerifyWhatsapp(telephone: any, token: any){
      return this.datasource.putVerifyWhatsapp({ telephone, token })
    }
    addCustomerCard(card: any) {
      return this.datasource.addCustomerCard(card);
    }
    putAvatar(avatar: any, avatar_provider: string) {
      const data = {avatar, avatar_provider}
      return this.datasource.putAvatar(data);
    }
    getUser(){
      return  this.datasource.getUser();
    }
    getUserMeta(key: string){
      return  this.datasource.getUserMeta(key);
    }
    getCustomer() {
      return this.datasource.getCustomer();
    }
    deleteCustomerCard(id: string) {
      return this.datasource.deleteCustomerCard(id);
    }
    getCustomerCards() {
      return this.datasource.getPaymentCards();
    }
    deleteCustomerSubscription(id: any) {
      return this.datasource.deleteCustomerSubscription(id);
    }
    getCustomerSubscriptions() {
      return this.datasource.getCustomerSubscriptions();
    }
    getCustomerPayments() {
      return this.datasource.getCustomerPayments();
    }
    postUserCreate(data: any):Observable<any> {
        return this.datasource.postUserCreate(data);
    }
    postRegister(data: any): Observable<any>{
        return this.datasource.postRegister(data);
    }
    deleteEmailValidation(res: any) {
        return this.datasource.deleteEmailValidation(res);
    }
    resendEmailValidation(data: any){
        return this.datasource.resendEmailValidation(data);
      }
    getUserPlans(planType: any, timeUnit: string) {
		return this.datasource.getUserPlans(planType, timeUnit)
	}
  postCheckLicense(){
    return this.datasource.postCheckLicense();
  }
  // Misma lógica que ya está duplicada en app.component.ts/sidenav.component.html/
  // profile.component.ts/education-access.guard.ts (managed_by?.type === 'education') —
  // centralizada acá para que código nuevo (ej. el encabezado de "Historia clínica") no la
  // repita una quinta vez. No reemplaza los 4 usos existentes.
  getAccountType(): Observable<AccountType> {
    return this.postCheckLicense().pipe(
      map((res: any) => {
        const type = res?.managed_by?.type;
        return type === 'education' ? 'edu' : (type ? 'one' : 'ind');
      }),
      catchError(() => of('ind' as AccountType))
    );
  }
    confirmForgotPassword(email: string, token: string, password: string){
        return this.datasource.confirmForgotPassword(email, token, password)
      }
      forgotPassword(email: string){
        return this.datasource.forgotPassword(email)
      }
} 
